/**
 * 소셜 로그인에서 돌아온 자리 /auth/done?ticket=… 또는 ?error=… (D108).
 *
 * - 일회용 표(2분 · 한 번)를 세션 토큰으로 바꾸고, 첫 방문 중이면 멈춘 장면 · 새 계정이면 가입 동의 · 아니면 별채대화로
 *   (landingPathOf). 기록을 바꿔치기(replace)해 뒤로 가기로 이 화면에 다시 오지 않습니다
 * - 앱이면 먼저 앱 안 브라우저를 닫습니다(iOS 는 앱이 불려도 그 브라우저가 위에 남음)
 * - 취소 · 실패면 시작 화면에 토스트 「로그인을 마치지 못했어요. 다시 해 볼까요?」
 * - 개발 중 StrictMode 가 효과를 두 번 돌려도 표는 한 번만 냅니다(두 번째는 이미 쓴 표라 실패로 보임)
 */
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { redeemTicket } from '../../api/auth.js';
import { closeLoginBrowser } from '../../lib/social.js';
import { useSession } from '../../stores/session.js';
import { landingPathOf } from '../../components/RouteGuards.jsx';

const redeeming = new Map();

/** 같은 표를 두 번 내밀지 않습니다 */
export function redeemOnce(ticket, redeem = redeemTicket) {
    if (!redeeming.has(ticket)) {
        redeeming.set(ticket, redeem(ticket));
    }
    return redeeming.get(ticket);
}

export function AuthDonePage() {
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const setSession = useSession((state) => state.setSession);
    const ticket = params.get('ticket');
    const error = params.get('error');

    useEffect(() => {
        let alive = true;
        const fail = () => {
            if (alive) {
                navigate('/start', { replace: true, state: { loginFailed: true } });
            }
        };
        closeLoginBrowser();
        if (error || !ticket) {
            fail();
            return () => {
                alive = false;
            };
        }
        redeemOnce(ticket)
            .then(({ token, user }) => {
                if (!alive) {
                    return;
                }
                if (!token || !user) {
                    fail();
                    return;
                }
                setSession({ token, user });
                navigate(landingPathOf(user), { replace: true });
            })
            .catch(fail);
        return () => {
            alive = false;
        };
    }, [ticket, error]);

    return (
        <main className="flex min-h-dvh items-center justify-center bg-bg" aria-busy="true">
            <p className="m-0 text-body text-text-secondary">들어가는 중이에요</p>
        </main>
    );
}
